<template>
  <div :class="customClass ? customClass : 'form-group'">
    <label
      v-if="!hideLabel && titulo != 'hide'"
      v-bind:class="{
        'text-danger': current.errors && current.errors.proveedor,
      }"
      >{{ titulo }}</label
    >
    <v-select
      :class="vSelectClass"
      label="nombre"
      v-model="current.proveedor"
      :disabled="disabled"
      :filterable="false"
      :options="proveedores"
      @search="onSearch"
      @input="onChange($event)"
      placeholder="- Proveedor -"
    >
      <template slot="no-options">Proveedor...</template>
      <template slot="option" slot-scope="option">
        <div v-if="option && option.codigo" class="selected d-center">
          {{ option.codigo }} - {{ option.nombre }}
        </div>
        <div v-if="option && option.codigo" class="selected d-center">
          <small> Nit: {{ option.nit }} </small>
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div v-if="option && option.codigo" class="selected d-center">
          {{ option.codigo }} - {{ option.nombre }}
        </div>
        <div v-if="option && option.codigo" class="selected d-center">
          <small> &nbsp;&nbsp;&nbsp;Nit: {{ option.nit }} </small>
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.proveedor"
      class="form-text text-danger"
      >{{ current.errors.proveedor }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    titulo: {
      type: String,
      default: "Proveedor",
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    vSelectClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      proveedores: "catalogos/proveedores",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/proveedores", {
      activo: true,
      page: 1,
      quitar_paginacion: true,
    });
  },
  methods: {
    onChange(event) {
      this.$emit("onChange", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/proveedores", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      // vm.proveedores = that.tiendas;
      loading(false);
      /*ProveedorService.fetch().then(res => {
        vm.proveedores = res.data;
        
      });*/
    }, 350),
  },
};
</script>